<template>
  <div>
    <div v-if="entity.sections">
      <!-- Box 1 -->
      <div class="card">
        <div class="card-header">
          <strong>Box 1</strong>
          <div class="card-collapse">Collapse</div>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="branch-main-about" class="col-md-2">About</label>
                  <div class="col-md-10">
                    <ckeditor id="branch-main-about" v-model="entity.boxes.box1.text" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="box1-include-slider" class="col-md-2">Show Photos Slider</label>
                  <div class="col-md-10">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <div class="branch_tooltip">
                          <input
                            id="box1-include-slider"
                            v-model="entity.boxes.box1.show_images_slider"
                            type="checkbox"
                            :disabled="isImagesSliderSelected && !entity.boxes.box1.show_images_slider"
                          >
                          <span
                            v-if="isImagesSliderSelected && !entity.boxes.box1.show_images_slider"
                            class="branch_tooltiptext"
                          >
                            Please use one image slider
                          </span>
                        </div>
                      </div>
                      <div v-show="entity.boxes.box1.show_images_slider" class="col-md-12 mt-2">
                        <dropzone
                          v-if="dropzoneOptions"
                          id="files-uploader"
                          ref="dropzone"
                          :options="dropzoneOptions"
                          :destroy-dropzone="false"
                          @vdropzone-file-added="fileUploadedSuccess"
                          @vdropzone-removed-file="fileRemoved"
                        />
                        <div v-else>Dropzone can't work without upload url.</div>
                        <!-- Select Files Button -->
                        <div class="mt-3">
                          <button class="btn btn-success" @click.prevent="$refs.dropzone.dropzone.element.click()">
                            Select Images
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Action Save -->
                <div class="mt-2">
                  <button class="btn btn-success" @click="save">
                    Save
                    <span class="btn-loader" style="display: none;" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Box 2 -->
      <div class="card">
        <div class="card-header">
          <strong>Box 2</strong>
          <div class="card-collapse">Collapse</div>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="branch-main-info" class="col-md-2">Info</label>
                  <div class="col-md-10">
                    <ckeditor id="branch-main-info" v-model="entity.boxes.box2.text" />
                  </div>
                </div>
                <!-- Action Save -->
                <div class="mt-2">
                  <button class="btn btn-success" @click="save">
                    Save
                    <span class="btn-loader" style="display: none;" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Box 3 -->
      <div class="card">
        <div class="card-header">
          <strong>Box 3</strong>
          <div class="card-collapse">Collapse</div>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="box3-show-news-notes" class="col-md-2">Show News Notes</label>
                  <div class="col-md-10">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <input
                          id="box3-show-news-notes"
                          v-model="entity.boxes.box3.show_news_notes"
                          type="checkbox"
                          :disabled="entity.boxes.box3.show_images_slider"
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="box3-show-announcements" class="col-md-2">Show Announcements</label>
                  <div class="col-md-10">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <div class="branch_tooltip">
                          <input
                            id="box3-show-announcements"
                            v-model="entity.boxes.box3.show_announcements"
                            type="checkbox"
                            :disabled="(isAnnouncementsSelected && !entity.boxes.box3.show_announcements)
                              || entity.boxes.box3.show_images_slider"
                          >
                          <span
                            v-if="isAnnouncementsSelected && !entity.boxes.box3.show_announcements"
                            class="branch_tooltiptext"
                          >
                            Please use one announcements list
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="box3-include-slider" class="col-md-2">Show Photos Slider</label>
                  <div class="col-md-10">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <div class="branch_tooltip">
                          <input
                            id="box3-include-slider"
                            v-model="entity.boxes.box3.show_images_slider"
                            type="checkbox"
                            :disabled="(isImagesSliderSelected && !entity.boxes.box3.show_images_slider)
                              || entity.boxes.box3.show_announcements || entity.boxes.box3.show_news_notes"
                          >
                          <span
                            v-if="isImagesSliderSelected && !entity.boxes.box3.show_images_slider"
                            class="branch_tooltiptext"
                          >
                            Please use one image slider
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Action Save -->
                <div class="mt-2">
                  <button class="btn btn-success" @click="save">
                    Save
                    <span class="btn-loader" style="display: none;" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Box 4 -->
      <div class="card">
        <div class="card-header">
          <strong>Box 4</strong>
          <div class="card-collapse">Collapse</div>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <!-- Socials -->
                <div class="card-body form-horizontal">
                  <div class="row">
                    <div class="col-12">
                      <div class="card-block">
                        <div v-show="noteShown" class="mb-5">
                          <div class="saving-alerts">
                            <div class="alert alert-info">
                              <div style="float:right;cursor:pointer;" @click="noteShown = !noteShown">
                                <i class="fa fa-times" />
                              </div>
                              <strong>Note:</strong>
                              <p>Please use a valid link</p>
                              <strong>Example:</strong>
                              <p>
                                For url
                                <strong> https://www.facebook.com/ellenwhiteestate </strong>
                                a valid link is <strong>ellenwhiteestate</strong>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="facebookLink" class="col-md-2">Facebook</label>
                          <div class="col-md-10">
                            <input
                              id="facebookLink"
                              v-model="entity.boxes.box4.socials.facebook"
                              type="text"
                              placeholder="Enter Facebook link"
                              class="form-control"
                              :disabled="entity.boxes.box4.show_announcements || entity.boxes.box4.show_images_slider"
                            >
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="instaLink" class="col-md-2">Instagram</label>
                          <div class="col-md-10">
                            <input
                              id="instaLink"
                              v-model="entity.boxes.box4.socials.instagram"
                              type="text"
                              placeholder="Enter Instagram link"
                              class="form-control"
                              :disabled="entity.boxes.box4.show_announcements || entity.boxes.box4.show_images_slider"
                            >
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="twitterLink" class="col-md-2">Twitter</label>
                          <div class="col-md-10">
                            <input
                              id="twitterLink"
                              v-model="entity.boxes.box4.socials.twitter"
                              type="text"
                              placeholder="Enter Twitter link"
                              class="form-control"
                              :disabled="entity.boxes.box4.show_announcements || entity.boxes.box4.show_images_slider"
                            >
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="pinterestLink" class="col-md-2">Pinterest</label>
                          <div class="col-md-10">
                            <input
                              id="pinterestLink"
                              v-model="entity.boxes.box4.socials.pinterest"
                              type="text"
                              placeholder="Enter Pinterest link"
                              class="form-control"
                              :disabled="entity.boxes.box4.show_announcements || entity.boxes.box4.show_images_slider"
                            >
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="youtubeLink1" class="col-md-2">Youtube Video or Playlist 1</label>
                          <div class="col-md-10">
                            <input
                              id="youtubeLink1"
                              v-model="entity.boxes.box4.socials.youtube1"
                              type="text"
                              placeholder="Enter Youtube Playlist link"
                              class="form-control"
                              :disabled="entity.boxes.box4.show_announcements || entity.boxes.box4.show_images_slider"
                            >
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="youtubeLink2" class="col-md-2">Youtube Video or Playlist 2</label>
                          <div class="col-md-10">
                            <input
                              id="youtubeLink2"
                              v-model="entity.boxes.box4.socials.youtube2"
                              type="text"
                              placeholder="Enter Youtube Playlist link"
                              class="form-control"
                              :disabled="entity.boxes.box4.show_announcements || entity.boxes.box4.show_images_slider"
                            >
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="youtubeLink3" class="col-md-2">Youtube Video or Playlist 3</label>
                          <div class="col-md-10">
                            <input
                              id="youtubeLink3"
                              v-model="entity.boxes.box4.socials.youtube3"
                              type="text"
                              placeholder="Enter Youtube Playlist link"
                              class="form-control"
                              :disabled="entity.boxes.box4.show_announcements || entity.boxes.box4.show_images_slider"
                            >
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="box4-show-announcements" class="col-md-2">Show Announcements</label>
                          <div class="col-md-10">
                            <div class="form-group row">
                              <div class="col-md-12">
                                <div class="branch_tooltip">
                                  <input
                                    id="box4-show-announcements"
                                    v-model="entity.boxes.box4.show_announcements"
                                    type="checkbox"
                                    :disabled="(isAnnouncementsSelected && !entity.boxes.box4.show_announcements)
                                      || entity.boxes.box4.show_images_slider
                                      || socialsExist"
                                  >
                                  <div v-if="entity.boxes.box4.show_announcements" class="col-md-12 mt-2" />
                                  <span
                                    v-if="socialsExist"
                                    class="branch_tooltiptext"
                                  >
                                    Use either socials or announcements
                                  </span>
                                  <span
                                    v-if="isAnnouncementsSelected
                                      && !entity.boxes.box4.show_announcements"
                                    class="branch_tooltiptext"
                                  >
                                    Please use one announcements list
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="box4-include-slider" class="col-md-2">Show Photos Slider</label>
                          <div class="col-md-10">
                            <div class="form-group row">
                              <div class="col-md-12">
                                <div class="branch_tooltip">
                                  <input
                                    id="box4-include-slider"
                                    v-model="entity.boxes.box4.show_images_slider"
                                    type="checkbox"
                                    :disabled="(isImagesSliderSelected && !entity.boxes.box4.show_images_slider)
                                      || entity.boxes.box4.show_announcements
                                      || socialsExist"
                                  >
                                  <span
                                    v-if="socialsExist"
                                    class="branch_tooltiptext"
                                  >
                                    Use either socials or image slider
                                  </span>
                                  <span
                                    v-if="isImagesSliderSelected
                                      && !entity.boxes.box4.show_images_slider"
                                    class="branch_tooltiptext"
                                  >
                                    Please use one image slider
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Action Save -->
                <div class="mt-2">
                  <button class="btn btn-success" @click="save">
                    Save
                    <span class="btn-loader" style="display: none;" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="card">
        <div class="card-header d-flex justify-content-between">
          <strong>There are no sections for this branch yet.</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.css';
import { uploadStatus } from '@/helpers/constants';
// Mixins
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';
import CommonPageMixin from '@/mixins/CommonPageMixin';
import config from '../../../config';

const { SUCCESS } = uploadStatus;
export default {
  name: 'MainPage',
  components: {
    dropzone: Dropzone,
  },
  mixins: [DefaultOptionsRequests, CommonPageMixin],
  props: {
    entity: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 2048,
      },
      saveErrorMessage: '',
      files: [],
      uploadedFiles: [],
      toDeleteFiles: [],
      noteShown: true,
    };
  },
  computed: {
    dropzoneOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.$store.state.user.accessToken.access_token}`,
          Accept: 'application/json',
        },
        method: 'POST',
        paramName: 'media',
        url: `${this.$config.app_api.host}${this.$config.app_api.prefix}branch_office/${this.$route.params.id}/file`,
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'image/*',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?',
      };
    },
    uploadingFiles() {
      const getUploadings = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadings) {
        return [];
      }
      return getUploadings(this.$route.params.id, 'branch_office');
    },
    socialsExist() {
      return Boolean(this.entity.boxes.box4.socials.facebook)
        || Boolean(this.entity.boxes.box4.socials.instagram)
        || Boolean(this.entity.boxes.box4.socials.twitter)
        || Boolean(this.entity.boxes.box4.socials.pinterest)
        || Boolean(this.entity.boxes.box4.socials.youtube1)
        || Boolean(this.entity.boxes.box4.socials.youtube2)
        || Boolean(this.entity.boxes.box4.socials.youtube3);
    },
    isImagesSliderSelected() {
      return !!(this.entity.boxes.box1.show_images_slider
        || this.entity.boxes.box3.show_images_slider
        || this.entity.boxes.box4.show_images_slider);
    },
    isAnnouncementsSelected() {
      return !!(this.entity.boxes.box3.show_announcements
        || this.entity.boxes.box4.show_announcements);
    },
  },
  watch: {
    uploadingFiles: {
      handler(val) {
        this.uploadedFiles = val.filter(file => file.status === SUCCESS).map(file => file.file);
        const { dropzone } = this.$refs;
        if (dropzone) {
          this.uploadedFiles.forEach(file => dropzone.removeFile(file));
          this.uploadedFiles.forEach((file) => {
            dropzone.manuallyAddFile(file, '/');
            $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src',
              'static/img/file-thumb.jpg');
          });
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.initCollapse();
    this.getSource();
  },
  destroyed() {
    $(document).off('click', '.card-collapse');
  },
  methods: {
    initCollapse() {
      $(document).on('click', '.card-collapse', function () {
        const $body = $(this).parents('.card').children('.card-body');
        if ($body.hasClass('collapse')) {
          $body.slideDown(function () {
            $(this).removeClass('collapse');
          });
        } else {
          $body.slideUp(function () {
            $(this).addClass('collapse');
          });
        }
      });
    },
    getSource() {
      if (this.entity.images) {
        this.manuallyAddFiles();
      }
    },
    manuallyAddFiles() {
      for (let i = 0; i < this.entity.images.length; i += 1) {
        const file = {
          file: {
            name: this.entity.images[i].file_name,
            size: this.entity.images[i].size,
          },
          url: this.entity.images[i].public_url,
        };
        this.$refs.dropzone.manuallyAddFile(file.file, file.url);
        if (!this.entity.images[i].mime_type.match(/image.*/)) {
          $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
        }
      }
    },
    fileUploadedSuccess(file) {
      this.files.push(file);
    },
    fileRemoved(file) {
      const fileIndex = _.findIndex(this.entity.images, item => item.file_name === file.name && item.size === file
        .size);
      if (fileIndex === -1) return;
      const fileId = this.entity.images[fileIndex].id;
      this.toDeleteFiles.push(fileId);
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('domain', this.entity.domain);
      postFormData.append('type', this.entity.type);
      postFormData.append('boxes', JSON.stringify(this.entity.boxes));
      postFormData.append('sections', JSON.stringify(this.entity.sections));
      postFormData.append('local_institution', this.entity.local_institution ? this.entity.local_institution : '');
      postFormData.append('library', this.entity.library ? this.entity.library : '');
      if (this.entity.description) {
        postFormData.append('description', this.entity.description);
      }
      postFormData.append('published', this.entity.published || false);
      postFormData.append('address', JSON.stringify(this.entity.address.address));
      postFormData.append('mail_address', JSON.stringify(this.entity.address.mail_address));
      postFormData.append('alt_address', JSON.stringify(this.entity.address.alt_address));
      postFormData.append('contacts', JSON.stringify(this.entity.contacts));
      postFormData.append('location', JSON.stringify(this.entity.location));
      postFormData.append('sections', JSON.stringify(this.entity.sections));
      postFormData.append('boxes', JSON.stringify(this.entity.boxes));
      return this.$apiHttp.post(`${this.$config.app_api.prefix}branch-offices/${this.$route.params.id}`,
        postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      const files = this.files.filter(file => !file.manuallyAdded);
      const {
        prefix,
        host,
      } = this.$config.app_api;
      const {
        acceptedFiles,
      } = this.dropzoneOptions;
      const vm = this;
      const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));
      if (this.toDeleteFiles.length) {
        for (let i = 0; i < this.toDeleteFiles.length; i += 1) {
          this.$apiHttp
            .delete(
              // eslint-disable-next-line max-len
              `${this.$config.app_api.host}${this.$config.app_api.prefix}branch-offices/${this.$route.params.id}/images/${this.toDeleteFiles[i]}`,
            )
            // eslint-disable-next-line no-loop-func
            .then(() => {
              this.entity.files.splice(i, 1);
            })
            .catch((error) => {
              console.error('error in delete file in site page request - ', error);
            });
        }
      }
      this.saveRequest().then(() => {
        $('.btn-success .btn-loader').hide();
        this.$store.commit('notifications/setSuccessNotification', 'Success!');
        $('.saving-alerts .alert-success').show();
        if (files && files.length > 0) {
          this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: this.$route.params.id,
            files: [...files],
            token,
            acceptedFiles,
            contentType: 'branch_office',
          });
          vm.files = [];
        }
      }).catch((error) => {
        $('.btn-success .btn-loader').hide();
        this.$store.commit('notifications/setDangerNotification', 'Error!');
        console.error('Error in update branch office query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// MainPage.vue?bc658544